import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SportsNavBar from "../../components/common/SportsNavBar";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { fetchOlympicsNews } from "../../services/api";

function Olympics() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    const data = await fetchOlympicsNews();
    setArticles(data);
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>FIFA News | Bharat Abroad Sports</title>
        <meta
          name="description"
          content="Latest FIFA tournaments, rankings, scores, and updates."
        />
      </Helmet>

      <SportsNavBar />

      <div
        style={{ background: "#f5f5f5", minHeight: "100vh", padding: "20px" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <NewsSection
            title="FIFA News"
            articles={articles}
            category="olympics"
          />
        </div>
      </div>
    </>
  );
}

export default Olympics;
